import { render, staticRenderFns } from "./FeaturedProjectsSection.vue?vue&type=template&id=3826c94e&scoped=true"
import script from "./FeaturedProjectsSection.vue?vue&type=script&lang=js"
export * from "./FeaturedProjectsSection.vue?vue&type=script&lang=js"
import style0 from "./FeaturedProjectsSection.vue?vue&type=style&index=0&id=3826c94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3826c94e",
  null
  
)

export default component.exports